module.exports = __webpack_public_path__ + "img/v1.12aaffdd.webp";